import { createAsyncThunk } from '@reduxjs/toolkit'
import ProcessMediaFix from './process-media-fix-model'
import {
  delete_processMediaFix,
  load_processMediaFixs,
  store_processMediaFix,
} from './processMediaFix-service'

export const LoadProcessMediaFixsAsync = createAsyncThunk<any, any>(
  'composer/load/processMediaFix',
  async (params: { uid: string }) => {
    return await load_processMediaFixs(params)
  },
)

export const CreateProcessMediaFixAsync = createAsyncThunk<any, any>(
  'composer/create/processMediaFix',
  async (params: ProcessMediaFix) => {
    return await store_processMediaFix(params)
  },
)

export const DeleteProcessMediaFixAsync = createAsyncThunk<any, any>(
  'composer/delete/processMediaFix',
  async (params) => {
    return await delete_processMediaFix(params)
  },
)
